import { IAlarmManagement } from '@interfaces/alarms/alarm';
import { IValueLabelColor } from '@interfaces/common/common';
import { TSelectOption } from '@interfaces/components/componentTypes';

import { EVendorsValues, TVendorsValues } from '@enums/common';

export const MAX_USERS_COLUMN_WIDTH = 200;

export const CUSTOM_ALARM_ID = 'I_99003';
export const CUSTOM_ALARM_NO_FILE_ID = 'I_99005';

export const statusAlarmManagementBooleanOptions: TSelectOption<boolean>[] = [
	{
		label: 'Enable',
		value: true,
	},
	{
		label: 'Disable',
		value: false,
	},
];

export const statusAlarmManagementStringOptions: TSelectOption<string>[] = [
	{
		name: 'enable',
		label: 'Enable',
		value: 'true',
	},
	{
		name: 'disable',
		label: 'Disable',
		value: 'false',
	},
];

export const columnHeaders: Record<string, Partial<Record<TVendorsValues, string>>> = {
	alarmId: {
		[EVendorsValues.limenet]: 'alarmId',
		[EVendorsValues.oran]: 'alarmId',
		[EVendorsValues.benetel]: 'alarmId',
		[EVendorsValues.flexidas]: 'alarmIndex',
	},
	alarmName: {
		[EVendorsValues.limenet]: 'name',
		[EVendorsValues.flexidas]: 'alarmName',
		[EVendorsValues.oran]: 'name',
		[EVendorsValues.benetel]: 'name',
	},
	group: {
		[EVendorsValues.oran]: 'group',
		[EVendorsValues.benetel]: 'group',
	},
	groups: {
		[EVendorsValues.limenet]: 'groups',
	},
	roles: {
		[EVendorsValues.limenet]: 'roles',
		[EVendorsValues.oran]: 'roles',
		[EVendorsValues.benetel]: 'roles',
	},
	users: {
		[EVendorsValues.limenet]: 'users',
		[EVendorsValues.oran]: 'users',
		[EVendorsValues.benetel]: 'users',
	},
	status: {
		[EVendorsValues.limenet]: 'isEnabled',
		[EVendorsValues.oran]: 'status',
		[EVendorsValues.benetel]: 'status',
	},
	severity: {
		[EVendorsValues.limenet]: 'severity',
		[EVendorsValues.flexidas]: 'alarmSeverity',
		[EVendorsValues.oran]: 'severity',
		[EVendorsValues.benetel]: 'severity',
	},
	triggerCondition: {
		[EVendorsValues.limenet]: 'triggerCondition',
	},
	alarmCode: {
		[EVendorsValues.flexidas]: 'alarmCode',
	},
	nodeType: {
		[EVendorsValues.flexidas]: 'alarmNodeType',
	},
	masked: {
		[EVendorsValues.flexidas]: 'alarmMask',
	},
	hysteresis: {
		[EVendorsValues.flexidas]: 'alarmHysteresis',
	},
	description: {
		[EVendorsValues.flexidas]: 'alarmDescription',
	},
	applicability: {
		[EVendorsValues.oran]: 'applicability',
		[EVendorsValues.benetel]: 'applicability',
	},
	probableCause: {
		[EVendorsValues.oran]: 'probableCause',
		[EVendorsValues.benetel]: 'probableCause',
	},
	moduleName: {
		[EVendorsValues.oran]: 'moduleName',
		[EVendorsValues.benetel]: 'moduleName',
	},
	notes: {
		[EVendorsValues.limenet]: 'notes',
		[EVendorsValues.oran]: 'notes',
		[EVendorsValues.benetel]: 'notes',
	},
	actions: {
		[EVendorsValues.limenet]: 'actions',
		[EVendorsValues.oran]: 'actions',
		[EVendorsValues.benetel]: 'actions',
	},
};

export const getLimenetFormFields = (alarm?: IAlarmManagement): IValueLabelColor[] => {
	if (!alarm) return [];

	return [
		{
			label: 'Alarm Name',
			value: alarm.name,
		},
		{
			label: 'Severity',
			value: alarm?.severity.title,
			color: alarm?.severity.color,
		},
		{
			label: 'Code',
			value: alarm.codeName,
		},
		{
			label: 'Groups',
			value: alarm.groups.map(item => item.title).join(', '),
		},
		{
			label: 'Trigger Condition',
			value: alarm.triggerCondition,
		},
		{
			label: 'Notes',
			value: alarm.notes,
		},
	];
};

export const getOranFormFields = (alarm?: IAlarmManagement, vendor?: string): IValueLabelColor[] => {
	if (!alarm) return [];

	return [
		{
			label: 'Alarm Name',
			value: alarm.name,
		},
		{
			label: 'Severity',
			value: alarm?.severity.title,
			color: alarm?.severity.color,
		},
		{
			label: 'Module name',
			value: alarm.moduleName.title,
		},
		...(vendor ? [{
			label: 'Vendor',
			value: vendor,
		}] : []),
		{
			label: 'Group',
			value: alarm.group.title,
		},
		{
			label: 'Probable Cause',
			value: alarm.probableCause,
		},
	];
};
